module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/makenna-austin-6c0681834878484aeca318c191170bcf.jpg";